import { classify } from "./classify";
import { nextAttemptAt, nextReady, } from "./outbox";
const running = new WeakMap();
export function drain(options) {
    const current = running.get(options.store);
    if (current !== undefined) {
        return current;
    }
    const pass = runPass(options).finally(() => {
        running.delete(options.store);
    });
    running.set(options.store, pass);
    return pass;
}
async function runPass({ now, onReauth, random, scope, send, store, }) {
    await store.load();
    let sent = 0;
    const finish = (reason) => ({
        nextAttemptAt: nextAttemptAt(store.getState(), scope),
        reason,
        sent,
    });
    for (;;) {
        const item = nextReady(store.getState(), now(), scope);
        if (item === null) {
            return finish("idle");
        }
        // `nextReady` read a snapshot; `markInFlight` is what reaches the write
        // chain. A `withdrawUnsent` that got there first has removed the item, and
        // `markInFlight` on a missing id changes nothing. Whichever of the two
        // wins, the loser sees it here — so a withdrawn write is never sent, and
        // it is not counted as `sent`, so nothing invalidates for it either.
        const claimed = await store.markInFlight(item.id);
        const held = claimed.items.find((queued) => queued.id === item.id);
        if (held?.state !== "in_flight") {
            continue;
        }
        try {
            await send(item);
        }
        catch (error) {
            const failure = classify(error);
            await store.markFailed(item.id, failure, now(), random);
            if (failure.action === "reauth") {
                onReauth();
                return finish("reauth");
            }
            if (failure.action === "retry") {
                return finish("retry");
            }
            // Quarantined: visible, and it holds only its own session. Carry on
            // with the rest of the queue.
            continue;
        }
        await store.markDone(item.id);
        sent += 1;
    }
}
//# sourceMappingURL=runner.js.map